import React from 'react';
const Overlay = ({ bi }) => {
    return (
        <div className="ease" style={{
            position: 'absolute', top: 0, bottom: 0, left: 0, right: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.54)', background: `url("${bi}") no-repeat center center`, backgroundSize: 'cover'
        }} />
    );
}

export default Overlay;
//


// WEBPACK FOOTER //
// ./src/components/partials/background_image.js